import React from 'react';
import { Component } from "react";
import { API_URL } from '../../urls';
import DefaultLayout from "../../layouts/Default";
import masterHeadStyle from './HomePage.css';
import {APP_HOME_CAPTION, APP_HOME_ENTER_EMAIL_PLH,
  APP_HOME_ENTER_EMAIL_SIGN_UP, APP_HOME_TITLE,
  APP_HOME_SCIENCE_INTENSIVE, APP_HOME_SCIENCE_INTENSIVE_DESC,
  APP_HOME_MULTI_LEVEL, APP_HOME_MULTI_LEVEL_DESC,
  APP_HOME_EASY_TO_USE,APP_HOME_EASY_TO_USE_DESC,
  APP_HOME_VDS, APP_HOME_VDS_DESC,
  APP_HOME_DETAILS,
  APP_HOME_APP_BUILDER,
  APP_HOME_APP_BUILDER_DESC
} from '../../strings';
require('odatajs');
require('simple-line-icons/css/simple-line-icons.css');

class HomePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
          error: null,
          pending: false,
          data: {}
        };
      }
    componentDidMount() {
      document.title = APP_HOME_TITLE;
    }
    render() { 
        return (
<DefaultLayout>
  <header style={masterHeadStyle} class="text-white text-center">
    <div class="overlay"></div>
    <video playsinline="playsinline" autoplay="autoplay" muted="muted" loop="loop">
      <source src="./fon.mp4" type="video/mp4"/>
    </video>
    <div class="container">
      <div class="row">
        <div class="col-xl-9 mx-auto">
          <h1 class="mb-5">{APP_HOME_CAPTION}</h1>
        </div>
        <div class="col-md-10 col-lg-8 col-xl-7 mx-auto">
          <form onSubmit={(e) => {
            e.preventDefault();
            var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
            var request = {
                requestUri: API_URL + "Users/Default.Register",
                method: 'POST',
                headers: headers,
                data: { email: e.target.email.value }
            };
            window.odatajs.oData.request(
                request,
                (data, response) => {
                  window.location.href = "/user/confirm"; 
                },
                (err) => {
                    alert('Fail: ' + err.message);
                }
            );    

          }}>
            <div class="form-row">
              <div class="col-12 col-md-9 mb-2 mb-md-0">
                <input id="email" type="email" class="form-control form-control-lg" placeholder={APP_HOME_ENTER_EMAIL_PLH} />
              </div>
              <div class="col-12 col-md-3">
                <button type="submit" class="btn btn-block btn-lg btn-primary">{APP_HOME_ENTER_EMAIL_SIGN_UP}</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </header>

  {/* Icons Grid  */}
  <section class="features-icons bg-light text-center">
    <div class="container">
      <div class="row">
        <div class="col-lg-4">
          <div class="features-icons-item mx-auto mb-5 mb-lg-0 mb-lg-3">
            <div class="features-icons-icon d-flex">
              <i class="icon-screen-desktop m-auto text-primary"></i>
            </div>
            <h3>{APP_HOME_SCIENCE_INTENSIVE}</h3>
            <p class="lead mb-0">{APP_HOME_SCIENCE_INTENSIVE_DESC}</p>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="features-icons-item mx-auto mb-5 mb-lg-0 mb-lg-3">
            <div class="features-icons-icon d-flex">
              <i class="icon-layers m-auto text-primary"></i>
            </div>
            <h3>{APP_HOME_MULTI_LEVEL}</h3>
            <p class="lead mb-0">{APP_HOME_MULTI_LEVEL_DESC}</p>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="features-icons-item mx-auto mb-0 mb-lg-3">
            <div class="features-icons-icon d-flex">
              <i class="icon-check m-auto text-primary"></i>
            </div>
            <h3>{APP_HOME_EASY_TO_USE}</h3>
            <p class="lead mb-0">{APP_HOME_EASY_TO_USE_DESC}</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="row">
    <div class="col-sm-6">
      <div class="card">
        <img class="card-img-top" src="./img/big_data_center.jpg" alt="big data center"/>
        <div class="card-body">
          <h5 class="card-title">{APP_HOME_VDS}</h5>
          <p class="card-text">{APP_HOME_VDS_DESC}</p>
          <a href="/product/vds/intro" class="btn btn-primary">{APP_HOME_DETAILS}</a>
        </div>
      </div>
    </div>
    <div class="col-sm-6">
      <div class="card">
        <img class="card-img-top" src="./img/software_house.jpg" alt="big data center" />
        <div class="card-body">
          <h5 class="card-title">{APP_HOME_APP_BUILDER}</h5>
          <p class="card-text">{APP_HOME_APP_BUILDER_DESC}</p>
          <a href="/product/vsb/intro" class="btn btn-primary">{APP_HOME_DETAILS}</a>
        </div>
      </div>
    </div>
  </div>


  {/* <section class="testimonials text-center bg-light">
    <div class="container">
      <h2 class="mb-5">What people are saying...</h2>
      <div class="row">
        <div class="col-lg-4">
          <div class="testimonial-item mx-auto mb-5 mb-lg-0">
            <img class="img-fluid rounded-circle mb-3" src="img/testimonials-1.jpg" alt="" />
            <h5>Margaret E.</h5>
            <p class="font-weight-light mb-0">"This is fantastic! Thanks so much guys!"</p>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="testimonial-item mx-auto mb-5 mb-lg-0">
            <img class="img-fluid rounded-circle mb-3" src="img/testimonials-2.jpg" alt="" />
            <h5>Fred S.</h5>
            <p class="font-weight-light mb-0">"You are amazing. I've been using it to create lots of super nice applications."</p>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="testimonial-item mx-auto mb-5 mb-lg-0">
            <img class="img-fluid rounded-circle mb-3" src="img/testimonials-3.jpg" alt="" />
            <h5>Sarah W.</h5>
            <p class="font-weight-light mb-0">"Thanks so much for making these resources available to us!"</p>
          </div>
        </div>
      </div>
    </div>
  </section> */}

  {/* <!-- Call to Action --> */}
  {/* <section class="call-to-action text-white text-center">
    <div class="overlay"></div>
    <div class="container">
      <div class="row">
        <div class="col-xl-9 mx-auto">
          <h2 class="mb-4">Ready to get started? Sign up now!</h2>
        </div>
        <div class="col-md-10 col-lg-8 col-xl-7 mx-auto">
          <form>
            <div class="form-row">
              <div class="col-12 col-md-9 mb-2 mb-md-0">
                <input type="email" class="form-control form-control-lg" placeholder="Enter your email..."/>
              </div>
              <div class="col-12 col-md-3">
                <button type="submit" class="btn btn-block btn-lg btn-primary">Sign up!</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section> */}

  {/* <!-- Footer --> */}
  <footer class="footer bg-light">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 h-100 text-center text-lg-left my-auto">
          <ul class="list-inline mb-2">
            <li class="list-inline-item">
              <a href="/product/company/about">About</a>
            </li>
            <li class="list-inline-item">&sdot;</li>
            <li class="list-inline-item">
              <a href="/product/company/contact">Contact</a>
            </li>
            <li class="list-inline-item">&sdot;</li>
            <li class="list-inline-item">
              <a href="/product/company/terms">Terms of Use</a>
            </li>
            <li class="list-inline-item">&sdot;</li>
            <li class="list-inline-item">
              <a href="/product/company/policy">Privacy Policy</a>
            </li>
          </ul>
          <p class="text-muted small mb-4 mb-lg-0">&copy; IVy Consulting 2021. All Rights Reserved.</p>
        </div>
        <div class="col-lg-6 h-100 text-center text-lg-right my-auto">
          <ul class="list-inline mb-0">
            <li class="list-inline-item mr-3">
              <a href="/">
                <i class="fab fa-facebook fa-2x fa-fw"></i>
              </a>
            </li>
            <li class="list-inline-item mr-3">
              <a href="/">
                <i class="fab fa-twitter-square fa-2x fa-fw"></i>
              </a>
            </li>
            <li class="list-inline-item">
              <a href="/">
                <i class="fab fa-instagram fa-2x fa-fw"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>

</DefaultLayout>
	);
    }
}
 
export default HomePage;